import { useUserNames } from './useUserNames';

/**
 * Display names for Azure AD provider IDs via GET /api/v1/store/users/names.
 * The bulk map includes all platform users; per-id fetches are not needed.
 */
export function useProviderDisplayNames(_providerIds: string[]) {
  const { data: displayNames = {}, isLoading, isError } = useUserNames();

  return {
    displayNames,
    isLoading,
    isError,
  };
}
